import React from "react";
import FeaturesSection from "../../Components/Home/FeaturesSection";
import ImageGrid from "../../Components/Home/ImageGrid";
import ScrollingText from "../../Components/Home/ScrollingText";
import Network from "../../Components/Home/Network";
import BrandsLogos from "../../Components/Home/LogoRow";
import WhatWeDo from "../../Components/Home/WhatWeDo";
import NewsBlogs from "../../Components/Home/NewsBlogs";
import NewHeroSection from "../../Components/Home/NewHeroSection";
// import TestimonialSection from "../../Components/Home/TestimonialSection";
// import HeroSection from "../../Components/Home/HeroSection";

const Home = () => {
  return (
    <div className="overflow-hidden">
      <NewHeroSection />
      {/* <HeroSection /> */}
      <FeaturesSection />
      <ImageGrid />
      {/* <ScrollingText /> */}
      <Network />
      <BrandsLogos />
      {/* <WhatWeDo /> */}
      <NewsBlogs />
      {/* <TestimonialSection /> */}
    </div>
  );
};

export default Home;
